<script setup lang="ts">
defineProps<{
	infoRefreshVersion: string;
	reload: string;
}>();
</script>

<template>
	<div>
		{{ infoRefreshVersion }} (<a
			class="underline"
			href=""
		>
			{{ reload }}
		</a>)
	</div>
</template>
